import React, { FormEvent } from 'react';

import { sendAvailabilityNotification } from '../Api/AvailabilityNotification';
import { AccountContext } from '../Context/AccountContext';
import Button from '../Form/Button/Button';
import MaterialInput from '../Form/MaterialInput/MaterialInput';

import './AvailabilityNotification.scss';

interface Props {
    articleNumber: string;
}

enum FormState {
    SENDING,
    SUCCESS,
    FAILURE,
}
const AvailabilityNotification: React.FunctionComponent<Props> = (props) => {
    const [email, updateEmail] = React.useState('');
    const [formstate, updateFormState] = React.useState<FormState | null>(null);
    const [infoText, updateInfoText] = React.useState('');
    const { accountData } = React.useContext(AccountContext);
    React.useEffect(() => {
        if (accountData && accountData.email) {
            updateEmail(accountData.email);
        }
    }, [accountData]);

    if (!props.articleNumber) {
        console.error('Can not render avaibility form without article numer');
        return null;
    }
    const onFormSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        sendAvailabilityNotification(
            email,
            props.articleNumber,
            (newInfoText) => {
                updateFormState(FormState.SUCCESS);
                updateInfoText(newInfoText);
            },
            (errorMessages) => {
                updateFormState(FormState.FAILURE);
                updateInfoText(errorMessages);
            },
            () => {
                updateFormState(FormState.FAILURE);
            },
        );
    };

    const onInputChange = (event: FormEvent<HTMLInputElement>) => {
        updateEmail(event.currentTarget.value);
    };

    if (formstate === FormState.SUCCESS) {
        return (
            <p className="availability-notification-form__info">
                {infoText || 'Sie erhalten eine E-Mail, wenn das Produkt wieder lieferbar ist.'}
            </p>
        );
    }

    if (formstate === FormState.FAILURE) {
        return (
            <p className="availability-notification-form__info availability-notification-form__info--error">
                {infoText ||
                    'Sie erhalten eine E-Mail, wenn das Produkt wieder lieferbar ist.' ||
                    'Es gab leider einen Fehler bei der Verarbeitung Ihrer Anfrage, bitte versuchen Sie es in Kürze noch einmal.'}
            </p>
        );
    }

    return (
        <>
            <form className="availability-notification-form" onSubmit={onFormSubmit}>
                <p>
                    Derzeit nicht lieferbar. Auf Wunsch informieren wir Sie per E-Mail, wenn das Produkt wieder
                    lieferbar ist.
                </p>
                <MaterialInput
                    name="email"
                    id="availability-email"
                    value={email}
                    required={true}
                    onChange={onInputChange}
                    label="E-Mail Adresse"
                />
                <Button>Senden</Button>
            </form>
        </>
    );
};

export default AvailabilityNotification;
